import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { trackWidgetVersion } from '@migros/msrc-analytics';
import { MessageTypes, messenger } from '@migros/msrc-messenger';
import { MsrcThemeProvider } from '@migros/msrc-ui-kit';
import React, { useEffect, useRef } from 'react';
// eslint-disable-next-line react/no-deprecated
import { unmountComponentAtNode } from 'react-dom';
import { ArticleMini } from '../../components/article-mini/ArticleMini';
import { Article } from '../../components/article/Article';
import { Fallback } from '../../components/fallback';
import { FallbackMini } from '../../components/fallback-mini';
import { ResponseStatus, TileLayout, defaultOptions } from '../../helpers';
import { extractTrackingInfoFromArticle, trackArticleTileImpression } from '../../helpers/tracking';
import { useI18n } from '../../hooks/use-i18n';
import { useData } from '../../hooks/useData';
import { fetchProducts } from '../../services/web-api';
export const ProductWidget = ({
  environment,
  webAPIKey,
  theme,
  language = defaultOptions.language,
  productId,
  filterOptions,
  mode = defaultOptions.mode,
  headingTagsLevel = defaultOptions.headingTagsLevel,
  hideDescription,
  hideRating = defaultOptions.hideRating,
  hideEnergyEfficiency = defaultOptions.hideEnergyEfficiency,
  hideBadge = defaultOptions.hideBadge,
  linkToFm = defaultOptions.linkToFm,
  layout = TileLayout.default,
  trackingInfo,
  trackingIndex = 0,
  index
}) => {
  useEffect(() => {
    trackWidgetVersion("1.84.0", 'msrc-articles:product-widget');
  }, []);
  useI18n(language);
  const widgetRef = useRef(null);
  let mergedTrackingIndex = trackingIndex || 0;
  if (index !== undefined) {
    console.warn('The index property is deprecated. Please use trackingIndex instead.');
    mergedTrackingIndex = index || 0;
  }
  const {
    entities,
    loading,
    responseStatus
  } = useData({
    environment,
    webAPIKey,
    language,
    articlesPerPage: 1,
    currentPage: 1,
    filterOptions: _objectSpread({
      ids: productId
    }, filterOptions),
    fetchFunction: fetchProducts
  });
  if (!productId) {
    return /*#__PURE__*/React.createElement("div", null, "productId is mandatory");
  }
  const article = entities.length > 0 ? entities[0] : undefined;
  // eslint-disable-next-line
  useEffect(() => {
    if (!loading && !article) {
      messenger.publish(MessageTypes.ArticlesProductNotFound, {
        productId,
        removeElement: () => {
          if (widgetRef && widgetRef.current) {
            unmountComponentAtNode(widgetRef.current.parentNode);
          }
        },
        widgetContainerNode: widgetRef && widgetRef.current ? widgetRef.current.parentNode : undefined
      });
    }
  }, [loading, JSON.stringify(article)]);
  const props = {
    article,
    hideEnergyEfficiency,
    hideDescription,
    hideRating,
    hideBadge,
    linkToFm,
    language,
    loading,
    mode,
    heading: headingTagsLevel,
    onClick: () => {
      if (article) {
        const {
          position,
          trackOnClick,
          trackingInformation,
          ratings
        } = extractTrackingInfoFromArticle(article, mergedTrackingIndex);
        trackOnClick(position, trackingInformation, article.id, ratings, trackingInfo);
      }
    },
    onImpression: () => {
      if (article) {
        const {
          position,
          defaultTrackingInformation,
          ratings
        } = extractTrackingInfoFromArticle(article, mergedTrackingIndex);
        trackArticleTileImpression(position, defaultTrackingInformation, article.id, trackingInfo, ratings);
      }
    }
  };
  return /*#__PURE__*/React.createElement(MsrcThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    ref: widgetRef
  }, responseStatus === ResponseStatus.ok ? /*#__PURE__*/React.createElement(React.Fragment, null, layout === TileLayout.default && /*#__PURE__*/React.createElement(Article, props), layout === TileLayout.mini && /*#__PURE__*/React.createElement(ArticleMini, props)) : /*#__PURE__*/React.createElement(React.Fragment, null, layout === TileLayout.default && /*#__PURE__*/React.createElement(Fallback, {
    hideRating: hideRating,
    mode: mode
  }), layout === TileLayout.mini && /*#__PURE__*/React.createElement(FallbackMini, {
    hideRating: hideRating,
    mode: mode
  }))));
};